import { matchPath } from 'react-router-dom';

type TPageLocation = Pick<Location, 'origin' | 'pathname'>;

/**
 * Link da página em que o lead do pré-chat nasceu: origem e caminho, sem a
 * query, e com o padrão da rota no lugar dos segmentos que são chave de
 * acesso (ex.: /cliente/reparcelamento/:hash).
 */
export default function buildWebchatLeadLink(
  { origin, pathname }: TPageLocation,
  maskedRoutes: string[],
): string {
  const maskedRoute = maskedRoutes.find(
    path => matchPath(pathname, { path, exact: true }) !== null,
  );

  return `${origin}${maskedRoute ?? pathname}`;
}
